<template>
    <the-form-layout :init-method="queryLocationConfig" :sure-method="updateLocationConfig">
        <template #default="{ data: form }">
            <the-form-section title="高德地图">
                <isc-form-item label="城市查询 Url">
                    <isc-input v-model="form.url" disabled></isc-input>
                </isc-form-item>
                <isc-form-item label="Web 服务 AppKey">
                    <isc-input v-model="form.webAppKey"></isc-input>
                </isc-form-item>
                <isc-form-item label="Web 端 AppKey">
                    <isc-input v-model="form.jsAppKey"></isc-input>
                </isc-form-item>
            </the-form-section>
        </template>
    </the-form-layout>
</template>

<script>
import TheFormLayout from '../components/the-form-layout';
import TheFormSection from '../components/the-form-section';
import { queryLocationConfig, updateLocationConfig } from './service';

export default {
    name: 'LbsConfig',

    components: {
        TheFormSection,
        TheFormLayout
    },

    data() {
        return {
            queryLocationConfig,
            updateLocationConfig
        };
    }
};
</script>

<style lang="scss" scoped></style>
